import { StyleSheet } from 'lib/paypalphrodite'

export default StyleSheet.create({
  addressWrapper: {
    padding: '0px 28px 0px',
  },
  toolCheckboxWrapper: {
    position: 'absolute',
    width: 'inherit',
    display: 'inline',
  },
  inputCheckBox: {
    width: 25,
    height: 20,
  },
  toolCheckbox: {
    ':before': {
      overflow: 'hidden',
      height: '1em',
      width: '1em',
      padding: '0.3em 0em',
    },
  },
  addressContent: {
    margin: '0 0 0 40px',
    display: 'inline-block',
  },
  srLabel: {
    position: 'absolute',
    width: 1,
    height: 1,
    overflow: 'hidden',
  },
  tipIcon: {
    color: '#005EA6',
    cursor: 'pointer',
    textDecoration: 'none',
    width: 0,
    height: 0,
    padding: 0,
  },
  toolTipTxt: {
    backgroundColor: '#e1e7eb',
    fontSize: 12,
    lineHeight: 1.8,
    textAlign: 'left',
    borderRadius: 6,
    padding: '5px 7px',
    display: 'block',
  },
})
